import { render, staticRenderFns } from "./MyVisit.vue?vue&type=template&id=f27f8586&"
import script from "./MyVisit.vue?vue&type=script&lang=js&"
export * from "./MyVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports